// @ts-nocheck

const localStorageKeyPrefix = "closeableBanner-"

export function CloseableBanner() {
    const banner = document.querySelector(".closeable-banner__wrapper");
    if (!banner) return;

    const date = Date.now();
    ClearLocalStorage(date);

    const hash = banner.dataset.hash;
    const pathHash = hashString(window.location.pathname);
    const storageKey = `${localStorageKeyPrefix}${hash}-${pathHash}`;
    const hideDurationInMinutes = parseInt(banner.dataset.hideDuration || "0");
    const lastClosed = localStorage.getItem(storageKey)?.split("|")[0];
    if (lastClosed && date - parseInt(lastClosed) < hideDurationInMinutes * 60000) {
        banner.classList.add("hidden");
        return;
    }

    banner.classList.remove("preload-hidden");

    const closeButton = banner.querySelector(".closeable-banner__close");
    if (!closeButton) return;

    closeButton.addEventListener("click", () => {
        banner.classList.add("hidden");
        localStorage.setItem(storageKey, `${date.toString()}|${hideDurationInMinutes}`);
    });
}

const ClearLocalStorage = (date) => {
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith(localStorageKeyPrefix)) {
            const value = localStorage.getItem(key);
            const split = value.split("|");
            if (split.length !== 2) {
                continue;
            }

            const oldTimestamp = parseInt(split[0]);
            const hideDuration = split[1];

            if (!isNaN(oldTimestamp) && !isNaN(hideDuration)) {
                if (date > oldTimestamp + hideDuration * 60000) {
                    localStorage.removeItem(key);
                }
            }
        }
    }
}

// Simple hash function (djb2)
const hashString = (str) => {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) + hash) + str.charCodeAt(i);
    }

    return hash >>> 0;
}